<script lang="ts">
  import posthog from "posthog-js";
  import { onMount } from "svelte";
  import { community } from "app/stores/community";
  import { browser } from "$app/environment";
  import { beforeNavigate, afterNavigate } from "$app/navigation";
  import { user } from "app/stores/auth";
  import { PUBLIC_ENV } from "$env/static/public";

  import { inject } from "@vercel/analytics";
  import * as Sentry from "@sentry/sveltekit";
  import { page } from "$app/stores";

  export let usingSubdomain = false;

  // trigger posthog on page navigations (skip /auth route to prevent tracking loops)
  beforeNavigate(() => {
    if ($page.url.pathname !== "/auth") {
      posthog.capture("$pageleave");
    }
  });
  afterNavigate(() => {
    if ($page.url.pathname !== "/auth") {
      posthog.capture("$pageview");
    }
  });

  // wait for analytics to load before indentifying user
  let loaded = false;

  onMount(() => {
    // set vercel analytics mode based on env
    const mode = {
      production: "production",
      staging: "development",
    }[PUBLIC_ENV] as "production" | "development" | undefined;

    // load vercel analytics
    if (mode) {
      inject({ mode });
    }

    if (!__IS_PROD__) {
      loaded = true;
      return;
    }

    if (usingSubdomain && $community.fetched && $community.gtmId) {
      // only use with subdomains because this doesn't unload when switching communities
      (function (w, d, s, l, i) {
        // @ts-ignore
        w[l] = w[l] || []; // @ts-ignore
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : ""; // @ts-ignore
        j.async = true; // @ts-ignore
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl; // @ts-ignore
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", $community.gtmId);

      // <!-- Google Tag Manager (noscript) -->
      const noscript = document.createElement("noscript");
      noscript.id = "gtm-noscript";
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${$community.gtmId}`;
      iframe.height = "0";
      iframe.width = "0";
      // @ts-ignore
      iframe.style = "display:none;visibility:hidden";
      noscript.appendChild(iframe);
      document.body.prepend(noscript);
      // <!-- End Google Tag Manager (noscript) -->
    }
    loaded = true;
  });

  // this is super hacky and temporary until we productize communities being able
  // to add their own scripts
  // this is now hardcoded for the hubspot devhub community

  $: if (browser) {
    if (__IS_PROD__ && $community.fetched && $community.uuid === "co2qUXOySqOn") {
      let script = document.createElement("script");

      script.type = "text/javascript";
      script.id = "hs-script-loader";
      script.async = true;
      script.defer = true;
      // not currently whitelisted in CSP so this will not be functional
      script.src = "//js.hs-scripts.com/23793071.js";
      document.body.appendChild(script);
    } else {
      let script = document.getElementById("hs-script-loader");
      if (script) {
        try {
          script.remove();
        } catch (error) {
          console.error("Error removing hubspot script", error);
        }
      }
      // delete hubspot object
      window._hsq = undefined;
    }
  }

  // identify user for analytics
  $: if (__IS_PROD__ && loaded && browser && $user && $user.uuid) {
    posthog.identify($user.uuid, {
      name: $user.name,
      email: $user.email,
    });
    window.hj?.("identify", $user.uuid, {
      email: $user.email,
      name: $user.name,
    });
    // set user for sentry
    Sentry.setUser({ email: $user.email! });
  }
</script>
